import { AxiosResponse } from 'axios';
import { IHeader } from 'models';
import { get } from '../axiosprovider';

const getOpportunityContract = async (id: string): Promise<AxiosResponse<IGetOpportunityContractResponse>> => {
	return await get<IGetOpportunityContractResponse>(`/api/contracts/${id}`);
};

export const contractsController = {
	getOpportunityContract
};

export interface IGetOpportunityContractResponse {
	header: IHeader;
}
